import { Box, Flex, useColorModeValue } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import AssociadoSidebar from '../pages/UsersArea/Associado/Sidebar/AssociadoSidebar';

const AssociadoLayout = () => {
  const bg = useColorModeValue('gray.50', 'gray.900');

  return (
    <Flex minH="100vh" bg={bg}>
      <AssociadoSidebar />
      
      <Box
        flex="1"
        ml={{ base: 0, lg: "250px" }}
        transition="margin-left 0.3s"
      >
        <Outlet />
      </Box>
    </Flex>
  );
};

export default AssociadoLayout;